import { render } from "./ReadOnly.vue?vue&type=template&id=5e493d6e"
import script from "./ReadOnly.vue?vue&type=script&lang=ts"
export * from "./ReadOnly.vue?vue&type=script&lang=ts"
script.render = render

export default script